import {TStateSetter} from 'shared/types/generics';

export const checkReadFlag = (
    data: Record<string, any>,
    userId: number,
    ref: { needRead: boolean; prevState: boolean; firstRender: boolean },
    setNeedRead: TStateSetter<boolean>,
) => {
    const readFlag = data?.dataTable?.find((news: Record<string, any>) => news?.notificationAssignments?.find(
        (notification: Record<string, any>) => notification?.assigneeId === userId && !notification.read,
    ));
    if (ref.firstRender && readFlag) {
        setNeedRead(true);
        ref.firstRender = false;
        ref.needRead = true;
    } else if (ref.firstRender && !readFlag) {
        setNeedRead(false);
        ref.firstRender = false;
        ref.needRead = false;
    } else if (readFlag) {
        ref.needRead = true;
        setNeedRead(true);
    } else if (!readFlag && ref.prevState !== ref.needRead) {
        ref.needRead = false;
        setNeedRead(false);
    }
};
